// FRONTEND

import { UilHtml5Alt } from "@iconscout/react-unicons";
import { RiCss3Line } from "react-icons/ri";
import { UilJavaScript } from "@iconscout/react-unicons";
import { FaReact } from "react-icons/fa";
import { SiNextdotjs } from "react-icons/si";
import { BsBootstrap } from "react-icons/bs";
import { SiMaterialui } from "react-icons/si";
import { SiSass } from "react-icons/si";
import { SiJquery } from "react-icons/si";
import { SiTypescript } from "react-icons/si";

// BACKEND

import { SiMongodb } from "react-icons/si";
import { SiFirebase } from "react-icons/si";
import { SiExpress } from "react-icons/si";
import { SiHeroku } from "react-icons/si";
 
// OTHER

import { UilCodeBranch } from "@iconscout/react-unicons";
import { AiFillApi } from "react-icons/ai";
import { SiNodedotjs } from "react-icons/si";
import { SiBigcommerce } from "react-icons/si";
import { SiWordpress } from "react-icons/si";
import { SiJira } from "react-icons/si";



export const skillsData = [
    {
        skillName: "HTML",
        containerClassName: "first-container",
        icon: <UilHtml5Alt />,
        stack: "Frontend", 
        id: 1,
    },
    {
        skillName: "Css",
        containerClassName: "second-container",
        icon: <RiCss3Line />,
        stack: "Frontend", 
        id: 2,
    },
    {
        skillName: "SASS",
        containerClassName: "fourth-container",
        icon: <SiSass />,
        stack: "Frontend", 
        id: 3,
    },
    {
        skillName: "JavaScript",
        containerClassName: "fourth-container",
        icon: <UilJavaScript />,
        stack: "Frontend", 
        id: 4,
    },
    {
        skillName: "ReactJS",
        containerClassName: "third-container",
        icon: <FaReact />,
        stack: "Frontend", 
        id: 5,
    },
    {
        skillName: "jQuery",
        containerClassName: "first-container",
        icon: <SiJquery />,
        stack: "Frontend", 
        id: 6,
    },
    {
        skillName: "NextJS",
        containerClassName: "first-container",
        icon: <SiNextdotjs />,
        stack: "Frontend", 
        id: 7,
    },
    {
        skillName: "Typescript",
        containerClassName: "fourth-container",
        icon: <SiTypescript />,
        stack: "Frontend", 
        id: 8,
    },
    {
        skillName: "Bootstrap",
        containerClassName: "second-container",
        icon: <BsBootstrap />,
        stack: "Frontend", 
        id: 9,
    },
    {
        skillName: "MaterialUi",
        containerClassName: "second-container",
        icon: <SiMaterialui />,
        stack: "Frontend", 
        id: 10,
    },
    {
        skillName: "Node JS",
        containerClassName: "fourth-container",
        icon: <SiNodedotjs />,
        stack: "Backend", 
        id: 11,
    },
    {
        skillName: "MongoDB",
        containerClassName: "first-container",
        icon: <SiMongodb />,
        stack: "Backend", 
        id: 12,
    },
    {
        skillName: "ExpressJS",
        containerClassName: "third-container",
        icon: <SiExpress />,
        stack: "Backend", 
        id: 13,
    },
    {
        skillName: "REST API",
        containerClassName: "first-container",
        icon: <AiFillApi />,
        stack: "Other", 
        id: 14,
    },
    {
        skillName: "Firebase",
        containerClassName: "first-container",
        icon: <SiFirebase />,
        stack: "Backend", 
        id: 15,
    },
    {
        skillName: "Heroku",
        containerClassName: "first-container",
        icon: <SiHeroku />,
        stack: "Other", 
        id: 16,
    },
    {
        skillName: "Git",
        containerClassName: "fourth-container",
        icon: <UilCodeBranch />,
        stack: "Other", 
        id: 17,
    },
    {
        skillName: "Jira",
        containerClassName: "second-container",
        icon: <SiJira />,
        stack: "Other", 
        id: 18,
    },
    {
        skillName: "Wordpress",
        containerClassName: "first-container",
        icon: <SiWordpress />,
        stack: "Other", 
        id: 19,
    },
    {
        skillName: "BigCommerce",
        containerClassName: "fourth-container",
        icon: <SiBigcommerce />,
        stack: "Other", 
        id: 20,
    },
]